import { MembershipAddOnType, MemberType } from 'src/models/responses/packages-response';

export enum AssociatedMemberType {
  ADULT = 'ADULT',
  INFANT = 'INFANT',
  CHILD = 'CHILD',
  CHILD_OLDER = 'CHILD_OLDER',
  NANNY = 'NANNY',
}

export const getAssociatedMemberTypeForMembershipAddOnType = (
  addOnType: MembershipAddOnType
): AssociatedMemberType => {
  return addOnType === MembershipAddOnType.PARTNER
    ? AssociatedMemberType.ADULT
    : AssociatedMemberType[addOnType];
};

export const getAssociatedMemberTypeForMemberType = (
  memberType: Exclude<MemberType, MemberType.PRIMARY>
): AssociatedMemberType => {
  return memberType === MemberType.PARTNER
    ? AssociatedMemberType.ADULT
    : AssociatedMemberType[memberType];
};
